import type { BranchesState } from './types';
import {
  SET_BRANCHES,
  SET_DS_BRANCHES,
  SET_DS_PUBLISHED_BRANCH_ID,
} from './branchesActionTypes';
import type { Reducer } from 'types/redux';

export const branchesInitialState: BranchesState = {
  currentBranchName: undefined,
  branchesList: [],
  wasBranchesListFetched: false,
  hasBranches: undefined,
  dsBranchesList: [],
  dsPublishedBranchId: undefined,
};

const reducer: Reducer<BranchesState> = (
  branches = branchesInitialState,
  action,
) => {
  switch (action.type) {
    case SET_BRANCHES:
      return Object.assign({}, branches, {
        branchesList: action.branchesList,
        wasBranchesListFetched: true,
        currentBranchName: action.currentBranchName,
        hasBranches: action.hasBranches,
      });
    case SET_DS_BRANCHES:
      return Object.assign({}, branches, {
        dsBranchesList: action.branchesList,
      });
    case SET_DS_PUBLISHED_BRANCH_ID:
      return Object.assign({}, branches, {
        dsPublishedBranchId: action.publishedBranchId,
      });
    default:
      return branches;
  }
};

export default reducer;
